import styled, { css, keyframes } from "styled-components";

/* ---------------- Animations ---------------- */

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(.95);
  }
  to {
    transform: scale(1);
  }
`;

const scaleOut = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(.95);
  }
`;

/* ---------------- Wrapper ---------------- */

export const TooltipWrapper = styled.span`
  display: inline-flex;
  position: relative;
`;

/* ---------------- Portal Container ---------------- */

export const TooltipContainer = styled.div`
  position: fixed;

  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;

  z-index: ${({ zIndex }) => zIndex || 9999};

  pointer-events: none;

  will-change: transform, opacity;
`;

/* ---------------- Bubble ---------------- */

export const TooltipBubble = styled.div`
  position: relative;

  max-width: ${({ maxWidth }) => maxWidth || 280}px;
  min-width: fit-content;

  padding: 10px 14px;

  border-radius: var(--tooltip-radius, 8px);

  background: var(--tooltip-bg, #ffffff);
  color: var(--tooltip-color, #202124);

  font-size: var(--tooltip-font-size, 13px);
  line-height: 1.5;

  white-space: normal;
  word-break: break-word;

  box-shadow: var(
    --tooltip-shadow,
    0 12px 28px rgba(0, 0, 0, 0.18)
  );

  user-select: none;

  transform-origin: center;

  animation: ${({ visible }) =>
      visible
        ? css`${fadeIn} .18s ease, ${scaleIn} .18s ease`
        : css`${fadeOut} .15s ease, ${scaleOut} .15s ease`};

  transition:
      transform .18s ease,
      opacity .18s ease;
`;

/* ---------------- Arrow ---------------- */

export const TooltipArrow = styled.div`
  position: absolute;

  width: 10px;
  height: 10px;

  background: var(--tooltip-bg, #fff);

  transform: rotate(45deg);

  ${({ placement }) => {

    switch (placement) {

      case "top":
      case "top-start":
      case "top-end":
        return css`
          bottom: -5px;
          left: 50%;
          margin-left: -5px;
        `;

      case "bottom":
      case "bottom-start":
      case "bottom-end":
        return css`
          top: -5px;
          left: 50%;
          margin-left: -5px;
        `;

      case "left":
      case "left-start":
      case "left-end":
        return css`
          right: -5px;
          top: 50%;
          margin-top: -5px;
        `;

      case "right":
      case "right-start":
      case "right-end":
        return css`
          left: -5px;
          top: 50%;
          margin-top: -5px;
        `;

      default:
        return css`
          bottom: -5px;
          left: 50%;
          margin-left: -5px;
        `;
    }

  }}
`;

/* ---------------- Placement Offsets ---------------- */

export const PlacementStyles = {
  top: css`
    transform: translate(-50%, -100%);
  `,

  bottom: css`
    transform: translate(-50%, 0);
  `,

  left: css`
    transform: translate(-100%, -50%);
  `,

  right: css`
    transform: translate(0, -50%);
  `,

  "top-start": css`
    transform: translate(0, -100%);
  `,

  "top-end": css`
    transform: translate(-100%, -100%);
  `,

  "bottom-start": css`
    transform: translate(0, 0);
  `,

  "bottom-end": css`
    transform: translate(-100%, 0);
  `,

  "left-start": css`
    transform: translate(-100%, 0);
  `,

  "left-end": css`
    transform: translate(-100%, -100%);
  `,

  "right-start": css`
    transform: translate(0, 0);
  `,

  "right-end": css`
    transform: translate(0, -100%);
  `,
};